<template>
  <div :class="themeClass" :lang="langCode">
    <div id="app">
      <admin-layout>
        <router-view />
      </admin-layout>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import AdminLayout from './layouts/AdminLayout.vue';
import {mapState} from 'pinia';
import {useConfigurationStore} from '@hit/base';

export default defineComponent({
  name: 'App',
  components: {AdminLayout},
  created() {
    // Il faudra modifier quand on va récupérer la langue utilisateur. On en a besoin pour
    // le hit-container-table
    const configStore = useConfigurationStore();
    if (!configStore.configurations['company.locales']) {
      configStore.configurations['user.locale'] = 'fr-BE';
      configStore.configurations['company.locales'] = ['fr_be'];
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ['configuration']),
    themeClass() {
      return (this.configuration && this.configuration['user.theme']) || '';
    },
    langCode() {
      return 'fr';
    },
  },
});
</script>
